var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 30,
    viewBox: "0 0 18 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.98878 13.5735V5.06562C3.98878 2.40606 6.20804 0.251953 8.94909 0.251953H9.05073C11.7918 0.251953 14.011 2.40606 14.011 5.06562V13.5735C14.011 16.2331 11.7918 18.3872 9.05073 18.3872H8.94909C6.21143 18.3872 3.98878 16.2331 3.98878 13.5735ZM15.1495 19.4931C16.7792 17.9122 17.6771 15.809 17.6771 13.5735C17.6771 13.0816 17.2637 12.6813 16.7555 12.6813C16.2472 12.6813 15.8339 13.0816 15.8339 13.5735C15.8339 15.3307 15.1291 16.9862 13.8484 18.2277C12.5677 19.4727 10.8634 20.1546 9.05073 20.1546H8.94909C7.1364 20.1546 5.43214 19.4693 4.15141 18.2277C2.87067 16.9828 2.16593 15.3307 2.16593 13.5735C2.16593 13.0816 1.75257 12.6813 1.24434 12.6813C0.736112 12.6813 0.322754 13.0816 0.322754 13.5735C0.322754 15.809 1.22062 17.9122 2.85034 19.4931C4.27338 20.8737 6.103 21.7116 8.07832 21.9016V28.0077H3.98878C3.48055 28.0077 3.06719 28.408 3.06719 28.8999C3.06719 29.3918 3.48055 29.7921 3.98878 29.7921H14.011C14.5193 29.7921 14.9326 29.3918 14.9326 28.8999C14.9326 28.408 14.5193 28.0077 14.011 28.0077H9.92149V21.9016C11.8968 21.7116 13.7264 20.8737 15.1495 19.4931Z",
    fill: "#848484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicIcon);
export default __webpack_public_path__ + "static/media/mic-icon.f2f8bc3388bcb7c69ab5cf81b874867c.svg";
export { ForwardRef as ReactComponent };